<template>
  <div id="App">
      <div class="head" style="width: 1200px;margin: 0 auto;">

          <el-carousel  height="410px">
            <el-carousel-item v-for="(item, index) in banner" :key="item.id">
              <router-link :to="item.link">
                <img :src="item.picurl" alt="" style="width: 100%;">
              </router-link>
            </el-carousel-item>
          </el-carousel>
          <!-- 第一层end -->
      </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        info:[],
        banner:[],

      }
    },
   mounted () {
     this.recordapi();
   },
   methods:{
     recordapi(){
         var that = this;
         that.$api.post("/Products/headthree",{}).then(res => {
           console.log(res);
           that.info= res.info;
           that.banner= res.banner;
         });
     },
   }

   }
</script>



// WEBPACK FOOTER //
// src/components/public/headthree.vue